import LinkExternal from 'components/partials/links/components/link-external/LinkExternal';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';

const propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      hash: PropTypes.string
    })
  ]).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

const LinkNav = props => {
  const { to, children, className } = props;
  const args = Object.assign({}, props);
  let link;
  delete args.children;
  delete args.to;
  if (typeof to === 'string') {
    link = to;
  } else {
    const { pathname, search = '', hash = '' } = to;
    link = pathname + search + hash;
  }
  const Element = link.match('//') ? LinkExternal : NavLink;
  return (
    <Element to={link} className={className} {...args}>
      {children}
    </Element>
  );
};

LinkNav.propTypes = propTypes;

export default LinkNav;
